import { useContext } from 'react';

import { HabitManualEntryLoggingContext } from './habit-manual-entry-logging-context';

export const useOpenManualEntryLogging = () => {
  const { openManualEntryLogging } = useContext(HabitManualEntryLoggingContext);

  return openManualEntryLogging;
};
